document.addEventListener('DOMContentLoaded', () => {
  // --- LOGICAL RESTRUCTURE: Only evaluates and disables Sizes based on Selected Color ---
  const updateSizeAvailability = (productCard, masterSelect) => {
    const sizeSwatches = productCard.querySelectorAll('.size-swatch__radio');
    const selectedColorInput = productCard.querySelector('.color-swatch__radio:checked');
    
    // If no color is explicitly selected yet, default to a fallback or skip locking
    const activeColor = selectedColorInput ? selectedColorInput.value.trim() : null;

    // Helper to evaluate variant records inside the master select
    const checkSizeCombination = (colorVal, sizeVal) => {
      let isAvailable = false;
      
      Array.from(masterSelect.options).forEach((option) => {
        const opt1 = option.getAttribute('data-option-1')?.trim() || "";
        const opt2 = option.getAttribute('data-option-2')?.trim() || "";
        const isOptAvailable = option.getAttribute('available') === "true";

        // Standardize spacing/casing to prevent false negatives from strings
        const normalizedOpt1 = opt1.toLowerCase().replace(/\s+/g, '');
        const normalizedOpt2 = opt2.toLowerCase().replace(/\s+/g, '');
        const normalizedColor = (colorVal || "").toLowerCase().replace(/\s+/g, '');
        const normalizedSize = (sizeVal || "").toLowerCase().replace(/\s+/g, '');

        const isColorMatch = !colorVal || 
                             normalizedOpt1.includes(normalizedColor) || 
                             normalizedOpt2.includes(normalizedColor);
                             
        const isSizeMatch = !sizeVal || 
                            normalizedOpt1.includes(normalizedSize) || 
                            normalizedOpt2.includes(normalizedSize);

        if (isColorMatch && isSizeMatch && isOptAvailable) {
          isAvailable = true;
        }
      });
      return isAvailable;
    };

    // Evaluate each Size Swatch against the current Active Color selection
    sizeSwatches.forEach((sizeRadio) => {
      const sizeValue = sizeRadio.value.trim();
      const parentWrapper = sizeRadio.closest('.size-swatch-item') || sizeRadio.parentElement;
      
      if (!checkSizeCombination(activeColor, sizeValue)) {
        parentWrapper.classList.add('is-soldout');
        // Optional: Actually disable the radio button input so it can't be submitted
      } else {
        parentWrapper.classList.remove('is-soldout');
      }
    });
  };

  // 1. Listen for change events globally on the document
  document.addEventListener('change', (event) => {
    const triggeredInput = event.target;
    
    // Check if the changed element is a color or size swatch radio button
    if (triggeredInput.classList.contains('color-swatch__radio') || triggeredInput.classList.contains('size-swatch__radio')) {
      
      // 2. Find the closest parent product card container
      const productCard = triggeredInput.closest('.product-card');
      if (!productCard) return;

      // 3. Extract currently selected color and size values within this specific card
      const selectedColorInput = productCard.querySelector('.color-swatch__radio:checked');
      const selectedSizeInput = productCard.querySelector('.size-swatch__radio:checked');

      const selectedColor = selectedColorInput ? selectedColorInput.value.trim() : null;
      const selectedSize = selectedSizeInput ? selectedSizeInput.value.trim() : null;

      // 4. Find the master variant select element in this card
      const masterSelect = productCard.querySelector('select.variant-select');
      if (!masterSelect) return;

      // 5. Query the option that matches BOTH selected attributes
      let matchingOption = null;

      Array.from(masterSelect.options).forEach((option) => {
        const opt1 = option.getAttribute('data-option-1')?.trim() || "";
        const opt2 = option.getAttribute('data-option-2')?.trim() || "";

        const normalizedOpt1 = opt1.toLowerCase().replace(/\s+/g, '');
        const normalizedOpt2 = opt2.toLowerCase().replace(/\s+/g, '');
        const normalizedColor = (selectedColor || "").toLowerCase().replace(/\s+/g, '');
        const normalizedSize = (selectedSize || "").toLowerCase().replace(/\s+/g, '');

        const isColorMatch = !selectedColor || normalizedOpt1.includes(normalizedColor) || normalizedOpt2.includes(normalizedColor);
        const isSizeMatch = !selectedSize || normalizedOpt1.includes(normalizedSize) || normalizedOpt2.includes(normalizedSize);

        if (isColorMatch && isSizeMatch) {
          matchingOption = option;
        }
      });

      // 6. Action step: Update variant ID and trigger theme mechanics (Completely Intact)
      if (matchingOption) {
        const variantId = matchingOption.value;
        masterSelect.value = variantId;

        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
        
        const idInput = productCard.querySelector('input[name="id"]');
        if (idInput) idInput.value = variantId;
        
        const addToCartButton = productCard.querySelector('.product-form__cart-submit');
        if (addToCartButton) {
          if (matchingOption.getAttribute('available') == "true") {
            addToCartButton.disabled = false;
            const textEl = addToCartButton.querySelector("[data-add-to-cart-text]");
            if (textEl) textEl.innerHTML = `${theme.strings.addToCart}<svg class="icon icon--tail-right" viewBox="0 0 24 24"><path fill="currentColor" d="M22.707 11.293L15 3.586 13.586 5l6 6H2c-.553 0-1 .448-1 1s.447 1 1 1h17.586l-6 6L15 20.414l7.707-7.707c.391-.391.391-1.023 0-1.414z"></path></svg>`;
          } else {
            addToCartButton.disabled = true;
            const textEl = addToCartButton.querySelector("[data-add-to-cart-text]");
            if (textEl) textEl.textContent = "Sold out";
          }
        }
      }

      // Run size evaluation ONLY to adjust size option visibility based on chosen color
      updateSizeAvailability(productCard, masterSelect);
    }
  });

  // --- INITIALIZATION ---
  // Sets correct sizing cross-outs on first page paint based on default pre-selected colors
  document.querySelectorAll('.product-card').forEach((card) => {
    const masterSelect = card.querySelector('select.variant-select');
    if (masterSelect) {
      updateSizeAvailability(card, masterSelect);
    }
  });
});